import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container-fluid mtb15 no-fluid" }
const _hoisted_2 = { class: "row sm-gutters" }
const _hoisted_3 = {
  key: 0,
  class: "col-sm-12 col-md-2"
}
const _hoisted_4 = { class: "row align-items-center wallet-detail-header" }
const _hoisted_5 = { class: "col-sm-1 wallet-detail-back" }
const _hoisted_6 = { class: "col-sm-11 wallet-detail-title" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table trade-details-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppMenu = _resolveComponent("AppMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (1200 < $setup.getWindowsWidth)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_AppMenu)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["col-sm-12", { 'col-md-10': 1200 < $setup.getWindowsWidth }])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn btn-outline-secondary btn-light mb-2", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }]),
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.goBack()), ["prevent"]))
            }, "←", 2)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (1200 < $setup.getWindowsWidth)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_7, _toDisplayString($setup.getTradesLabel) + " - #" + _toDisplayString($setup.trade?.oid), 1))
              : (_openBlock(), _createElementBlock("h6", _hoisted_8, _toDisplayString($setup.getTradesLabel) + " - #" + _toDisplayString($setup.trade?.oid), 1))
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                }, _toDisplayString($setup.getStatusLabel), 3),
                _createElementVNode("td", {
                  class: _normalizeClass(["prop-value", [$setup.getTradeStatusClass($setup.trade), { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }]])
                }, _toDisplayString($setup.getTradeStatus($setup.trade)), 3)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                }, _toDisplayString($setup.getTradeIdLabel), 3),
                _createElementVNode("td", {
                  class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                }, _toDisplayString($setup.tradeIdentifier), 3)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                }, _toDisplayString($setup.getOrderIdLabel), 3),
                _createElementVNode("td", {
                  class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                }, _toDisplayString($setup.trade?.oid), 3)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                }, _toDisplayString($setup.getTimestampLabel), 3),
                _createElementVNode("td", {
                  class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                }, _toDisplayString($setup.getDate($setup.trade?.ts)), 3)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                }, _toDisplayString($setup.getTypeLabel), 3),
                _createElementVNode("td", {
                  class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                }, _toDisplayString($setup.getOrderType($setup.trade?.tt)), 3)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                }, _toDisplayString($setup.getOrderTypeLabel), 3),
                _createElementVNode("td", {
                  class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                }, _toDisplayString($setup.tradeOrderType), 3)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                }, _toDisplayString($setup.getCodeLabel), 3),
                _createElementVNode("td", {
                  class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                }, _toDisplayString($setup.trade?.sc), 3)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                }, _toDisplayString($setup.getNameLabel), 3),
                (0 === 'BG'.localeCompare($setup.getUserLanguage))
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 0,
                      class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                    }, _toDisplayString($setup.trade?.nBG ? $setup.trade?.nBG : $setup.trade?.nEN), 3))
                  : _createCommentVNode("", true),
                (0 === 'EN'.localeCompare($setup.getUserLanguage))
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 1,
                      class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                    }, _toDisplayString($setup.trade?.nEN), 3))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                }, _toDisplayString($setup.getExchangeLabel), 3),
                _createElementVNode("td", {
                  class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                }, _toDisplayString($setup.tradeExchangeCode), 3)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                }, _toDisplayString($setup.getInstrumentTypeLabel), 3),
                _createElementVNode("td", {
                  class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                }, _toDisplayString($setup.getInstrumentType($setup.trade?.stid)), 3)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                }, _toDisplayString($setup.getQuantityOrFaceValueLabel), 3),
                _createElementVNode("td", {
                  class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                }, _toDisplayString($setup.formatQuantityOrFaceValue($setup.getQuantityOrFaceValue())), 3)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                }, _toDisplayString($setup.getPriceLabel), 3),
                _createElementVNode("td", {
                  class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                }, _toDisplayString($setup.formatTradePrice($setup.trade?.sp)), 3)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                }, _toDisplayString($setup.getFeeLabel), 3),
                _createElementVNode("td", {
                  class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                }, _toDisplayString($setup.formatMoney($setup.trade?.fee || 0)), 3)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  class: _normalizeClass({ 'xsmall-font-size': 1200 > $setup.getWindowsWidth })
                }, _toDisplayString($setup.getTotalAmountLabel), 3),
                _createElementVNode("td", {
                  class: _normalizeClass(["prop-value", { 'xsmall-font-size': 1200 > $setup.getWindowsWidth }])
                }, _toDisplayString($setup.formatMoney($setup.getTotalAmount())), 3)
              ])
            ])
          ])
        ])
      ], 2)
    ])
  ]))
}